// src/pages/TrocarSenha.jsx
import React, { useState } from 'react';
import { Box, Paper, Typography, TextField, Button, InputAdornment, IconButton, LinearProgress } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import api from '../services/api';

export default function TrocarSenha() {
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmar, setConfirmar] = useState('');

  const [showAtual, setShowAtual] = useState(false);
  const [showNova, setShowNova] = useState(false);
  const [showConf, setShowConf] = useState(false);

  const [saving, setSaving] = useState(false);

  // força simples (opcional – só pra dar feedback)
  const passwordStrength = (s) => {
    if (!s) return 0;
    let p = 0;
    if (s.length >= 8) p += 30;
    if (/[A-Z]/.test(s)) p += 20;
    if (/[a-z]/.test(s)) p += 20;
    if (/\d/.test(s)) p += 15;
    if (/[^A-Za-z0-9]/.test(s)) p += 15;
    return Math.min(100, p);
  };

  const resetForm = () => {
    setSenhaAtual('');
    setNovaSenha('');
    setConfirmar('');
  };

  const handleSalvar = async () => {
    // validações locais
    if (!senhaAtual || !novaSenha || !confirmar) {
      alert('Informe senha_atual, nova_senha e confirmar_senha.');
      return;
    }
    if (novaSenha !== confirmar) {
      alert('Nova senha e confirmação não conferem.');
      return;
    }
    if (novaSenha.length < 6) {
      alert('A nova senha deve ter ao menos 6 caracteres.');
      return;
    }

    setSaving(true);
    try {
      await api.post('/usuarios/me/trocar-senha', {
        senha_atual: senhaAtual,
        nova_senha: novaSenha,
        confirmar_senha: confirmar,
      });
      alert('Senha alterada com sucesso!');
      resetForm();
    } catch (e) {
      // mostra erro vindo do backend se houver
      const msg = e?.response?.data?.error || 'Erro ao trocar senha.';
      alert(msg);
      console.error(e);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box p={3} display="flex" justifyContent="center">
      <Paper sx={{ width: 520, maxWidth: '100%', p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Trocar Senha
        </Typography>

        <TextField
          label="Senha atual"
          fullWidth
          margin="normal"
          type={showAtual ? 'text' : 'password'}
          autoComplete="current-password"
          value={senhaAtual}
          onChange={(e) => setSenhaAtual(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowAtual((v) => !v)} edge="end">
                  {showAtual ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <TextField
          label="Nova senha"
          fullWidth
          margin="normal"
          type={showNova ? 'text' : 'password'}
          autoComplete="new-password"
          value={novaSenha}
          onChange={(e) => setNovaSenha(e.target.value)}
          helperText="Use pelo menos 6 caracteres. Combine letras, números e símbolos para mais segurança."
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowNova((v) => !v)} edge="end">
                  {showNova ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {/* barra de força opcional */}
        {novaSenha && (
          <Box mt={1} mb={1}>
            <LinearProgress
              variant="determinate"
              value={passwordStrength(novaSenha)}
              sx={{ height: 8, borderRadius: 1 }}
            />
          </Box>
        )}

        <TextField
          label="Confirmar nova senha"
          fullWidth
          margin="normal"
          type={showConf ? 'text' : 'password'}
          autoComplete="new-password"
          value={confirmar}
          onChange={(e) => setConfirmar(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowConf((v) => !v)} edge="end">
                  {showConf ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Box mt={2} display="flex" gap={1} justifyContent="flex-end">
          <Button variant="outlined" onClick={resetForm} disabled={saving}>
            LIMPAR
          </Button>
          <Button variant="contained" onClick={handleSalvar} disabled={saving}>
            {saving ? 'SALVANDO...' : 'SALVAR'}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
